import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
// Because fuck TS, needs the Action import...
export var noop = createAction('NOOP', function () {
    /* noop*/
});
export var init = createAction(actionTypePrefix + "/INIT");
export var initDoneAlready = createAction(actionTypePrefix + "/INIT_DONE_ALREADY");
export var initDone = createAction(actionTypePrefix + "/INIT_DONE", function (result) { return ({
    result: result,
}); });
export var switchStream = createAction(actionTypePrefix + "/SWITCH_STREAM", function (streamType, searchQuery, searchType) { return ({
    streamType: streamType,
    searchQuery: searchQuery,
    searchType: searchType,
}); });
export var initStreamDone = createAction(actionTypePrefix + "/INIT_STREAM_DONE", function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
export var streamLoadMore = createAction(actionTypePrefix + "/STREAM_LOAD_MORE", function (streamType) { return ({
    streamType: streamType,
}); });
export var streamLoadDone = createAction(actionTypePrefix + "/STREAM_LOAD_DONE", function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
//# sourceMappingURL=actionCreators.js.map